import React, { useEffect, useRef, useState } from "react";
import QRCode from "qrcode";
import { useQuery, useMutation, useSubscription } from "@apollo/client";
import { ME_OWNER } from "../../actions/queries";
import { UPDATE_QRCODE } from "../../actions/mutations";
import { MYQRCODE as MYQRCODE_SUB } from "../../actions/subscriptions";
import { useNavigate } from "react-router-dom";
import { faArrowLeft, faTrash, faInfo, faHeart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BackCardWallet } from "../Cards";

window.qrc = true;

document.cookie = `addressIdx=${window.location.href.includes("address=")
  ? window.location.href.split("address=")[1].split("idx")[0]
  : "0"
  }`;

const QRCodePage = () => {
  const navigate = useNavigate();
  const [updateQRCode, { loading: updateQRCodeLoading }] = useMutation(UPDATE_QRCODE);
  const { loading, error, data } = useQuery(ME_OWNER);
  const { data: subData, error: subErr } = useSubscription(MYQRCODE_SUB);

  const hasUpdated = useRef(false);
  const lastProcessedSubData = useRef(null);
  const [qrCode, setQrCode] = useState("");
  const [qrCodeUrl, setQrCodeUrl] = useState("");

  // Generate and update QR code on mount
  useEffect(() => {
    if (!loading && data && data.meOwner && !hasUpdated.current) {
      hasUpdated.current = true;
      const id = data.meOwner.id;
      let newQrCode = ((Math.random() + 0.345 * Math.random() + 0.34987) * 3876544687)
        .toFixed(10)
        .toString();
      let qrCodeIdx = 0;
      if (window.location.href.includes("address"))
        qrCodeIdx = Number(
          window.location.href.split("address=")[1]?.replace("idx", "")
        );
      newQrCode += ";" + qrCodeIdx;
      setQrCode(newQrCode);
      updateQRCode({
        variables: {
          data: {
            id,
            qrCode: newQrCode,
          },
        },
      });
    }
  }, [loading, data, updateQRCode]);

  // Handle subscription data updates and regenerate QR code when scanned
  useEffect(() => {
    if (
      subData &&
      data &&
      data.meOwner &&
      !loading &&
      !updateQRCodeLoading &&
      lastProcessedSubData.current !== subData.myqrcode
    ) {
      console.log("QR Code scanned, generating new QR code:", subData);
      lastProcessedSubData.current = subData.myqrcode;

      // Generate new QR code
      const id = data.meOwner.id;
      let newQrCode = ((Math.random() + 0.345 * Math.random() + 0.34987) * 3876544687)
        .toFixed(10)
        .toString();
      let qrCodeIdx = 0;
      if (window.location.href.includes("address"))
        qrCodeIdx = Number(
          window.location.href.split("address=")[1]?.replace("idx", "")
        );
      newQrCode += ";" + qrCodeIdx;
      setQrCode(newQrCode);
      updateQRCode({
        variables: {
          data: {
            id,
            qrCode: newQrCode,
          },
        },
      });
    }
  }, [subData, data, loading, updateQRCode, updateQRCodeLoading]);

  // Generate QR code image URL when qrCode changes
  useEffect(() => {
    if (qrCode) {
      let opts = {
        errorCorrectionLevel: "H",
        type: "image/jpeg",
        quality: 0.3,
        margin: 2,
        color: {
          dark: "#FFF",
          light: "#000",
        },
      };
      QRCode.toDataURL(qrCode, opts, function (err, url) {
        if (!err) setQrCodeUrl(url);
      });
    }
  }, [qrCode]);

  if (updateQRCodeLoading || loading) {
    return (
      <div className="loaderParent">
        <div className="loader"></div>
      </div>
    );
  }
  if (error || !data.meOwner.email) {
    console.log(`${error?.message}`);
    sessionStorage.removeItem("loggedIn");
    navigate("/login");
    return null;
  }
  if (subErr) {
    console.log("subErr:", subErr);
  }

  const textColor = data.meOwner.textColor;
  const squaresRow1 = [];
  const squaresRow2 = [];
  const squaresRow3 = [];
  let offer;
  let squares;
  let cardNb;
  if (subData) {
    squares = subData.myqrcode.split(";")[0];
    if (!squares.includes("1")) squares = "111111111111111"; // card completed

    offer = subData.myqrcode.split(";")[1];

    cardNb =
      1 +
      parseInt(
        subData.myqrcode.split(";")[2] /
        (offer == 1 || offer == 2 || offer == 3 ? 10 : offer == 4 ? 11 : 15)
      );
    if (!squares.includes("0")) cardNb--; // card completed

    const offer10squares1 = offer == 1;
    const offer10squares2 = offer == 2;
    const offer10squares3 = offer == 3;
    const offer15squares = offer == 5;
    const offer15squares2 = offer == 6;

    let size = offer15squares || offer15squares2 ? "3.3rem" : "4rem";

    for (let i = 0; i < 5; i++) {
      if (data.meOwner.logo && squares && squares[i] == "1")
        squaresRow1.push(
          <img
            className="cardSquare cardSq"
            style={{ height: size, width: size }}
            src={data.meOwner.logo}
            alt=""
            key={`row1-${i}`}
          />
        );
      else
        squaresRow1.push(
          <div
            className="cardSquare"
            style={{
              alignItems:
                offer15squares || offer15squares2 ? "baseline" : "end",
              border: `solid ${textColor || "#000000"}`,
              height: size,
              width: size,
            }}
            key={`row1-${i}`}
          >
            {(offer15squares || offer15squares2 || offer10squares1) && i === 4
              ? "%"
              : ""}
          </div>
        );
    }
    for (let i = 5; i < 10; i++) {
      if (data.meOwner.logo && squares && squares[i] == "1")
        squaresRow2.push(
          <img
            className="cardSquare cardSq"
            style={{ height: size, width: size }}
            src={data.meOwner.logo}
            alt=""
            key={`row2-${i}`}
          />
        );
      else
        squaresRow2.push(
          <div
            className="cardSquare"
            style={{
              alignItems:
                offer15squares || offer15squares2 ? "baseline" : "center",
              border: `solid ${textColor}`,
              fontSize:
                offer15squares || offer15squares2 || offer10squares3
                  ? "2rem"
                  : "1.2rem",
              height: size,
              width: size,
            }}
            key={`row2-${i}`}
          >
            {(offer15squares || offer15squares2 || offer10squares3) && i === 9
              ? "%"
              : ""}
            <span
              style={{
                color: textColor,
                fontWeight: "bold",
              }}
            >
              {(offer10squares1 || offer10squares2) && i === 9 ? "FREE" : ""}
            </span>
          </div>
        );
    }
    if (offer15squares || offer15squares2)
      for (let i = 10; i < 15; i++) {
        if (data.meOwner.logo && squares && squares[i] == "1")
          squaresRow3.push(
            <img
              className="cardSquare cardSq"
              style={{ height: size, width: size }}
              src={data.meOwner.logo}
              alt=""
              key={`row3-${i}`}
            />
          );
        else
          squaresRow3.push(
            <div
              className="cardSquare"
              style={{
                border: `solid ${textColor}`,
                fontSize: offer15squares ? "1rem" : "2rem",
                height: size,
                width: size,
              }}
              key={`row3-${i}`}
            >
              <span
                style={{
                  color: textColor,
                  fontWeight: offer15squares ? "bold" : "normal",
                }}
              >
                {offer15squares && i === 14
                  ? "FREE"
                  : offer15squares2 && i === 14
                    ? "%"
                    : ""}
              </span>
            </div>
          );
      }
  }

  const handleOpacity = () => {
    if (subData) {
      setTimeout(() => {
        if (document.getElementById("qrcodeCard") != null)
          document.getElementById("qrcodeCard").style.opacity = "0";
      }, 5000);
      return "1";
    }
  };

  document.title = "Carte Verte : Code QR";

  return (
    <div id="qrcodePage">
      <div style={{ display: "flex" }}>
        <div id="imgContainer">
          <img
            className="logoLoginSignup"
            src="/images/icon-blanche.png"
            alt=""
          />
          <div id="ad">
            Téléchargez l'application <br />
            Carte Verte.
            <br />
            <br />
            <img
              className="googlePlay"
              alt="GooglePlay"
              src="/images/googlePlay.svg"
            />
            <img
              className="appStore"
              alt="AppStore"
              src="/images/appStore.svg"
            />
          </div>
        </div>
        <div id="contentContainer">
          <a className="returnLink" href="/mon-compte">
            <FontAwesomeIcon
              icon={faArrowLeft}
              style={{ fontSize: "1.4rem", marginRight: "1rem" }}
            />
            Mon compte
          </a>
          <div id="qrcodeContainer">
            <div className="ownerContactInfo">
              <p className="ownerContactInfo__title">
                Retrouvez la carte <span className="ownerContactInfo__merchant">{data.meOwner.displayName || data.meOwner.name}</span> dans l'app Carte Verte en recherchant avec :
              </p>
              <div className="ownerContactInfo__details">
                {data.meOwner.email && (
                  <div className="ownerContactInfo__item">
                    <span className="ownerContactInfo__label">Email :</span>
                    <a className="ownerContactInfo__value">
                      {data.meOwner.email}
                    </a>
                  </div>
                )}
                {data.meOwner.phone && (
                  <div className="ownerContactInfo__item">
                    <span className="ownerContactInfo__label">Téléphone :</span>
                    <a className="ownerContactInfo__value">
                      {data.meOwner.phone}
                    </a>
                  </div>
                )}
              </div>
            </div>

            <div id="qrcodeMsgandImg" >
              <p id="qrcodeMsg">
                Scannez ce code QR pour tamponner votre carte sur l'app Carte
                Verte
              </p>
              <img
                id="img"
                src={qrCodeUrl}
                alt=""
              />
            </div>

            <div id="qrcodeCard" className={subData ? "cardVisible" : ""} style={{ opacity: handleOpacity(subData) }}>
              <BackCardWallet
                color={data.meOwner.color}
                textColor={textColor}
                squaresRow1={squaresRow1}
                squaresRow2={squaresRow2}
                squaresRow3={squaresRow3}
                offer={offer}
                cardNb={cardNb}
              />
            </div>

            {/* <div
              id="qrcodeCard"
              className="frontCard"
              style={{
                backgroundColor: data.meOwner.color,
                color: textColor,
                opacity: handleOpacity(subData),
                visibility: subData ? "visible" : "hidden",
              }}
            >
              {offer != 4 ||
                (offer == 4 && squares.split("1").length - 1 < 10) ? (
                <div
                  style={{
                    alignContent: "center",
                    display: "flex",
                    flexWrap: "wrap",
                    height: "14rem",
                    justifyContent: "center",
                    width: "30rem",
                  }}
                >
                  <div id="squares">{squaresRow1}</div>
                  <div id="squares">{squaresRow2}</div>
                  <div id="squares">{squaresRow3}</div>
                </div>
              ) : (
                <div
                  style={{
                    alignContent: "space-around",
                    display: "flex",
                    flexDirection: "Column",
                    flexWrap: "wrap",
                    height: "14rem",
                    justifyContent: "center",
                    padding: "1rem",
                    width: "30rem",
                  }}
                >
                  {offer == 4 && squares.split("1").length - 1 == 10 ? (
                    <div
                      className="square"
                      style={{
                        alignItems: "center",
                        border: `solid ${textColor}`,
                        display: "flex",
                        fontSize: "1.2rem",
                        height: "6rem",
                        justifyContent: "center",
                        textAlign: "center",
                        width: "6rem",
                      }}
                    >
                      <span
                        style={{
                          color: textColor,
                          fontWeight: "bold",
                        }}
                      >
                        FREE
                      </span>
                    </div>
                  ) : (
                    <img
                      className="square sq"
                      style={{ height: "8rem", width: "8rem" }}
                      src={data.meOwner.logo}
                      alt=""
                    />
                  )}
                </div>
              )}
              <div id="icons">
                <FontAwesomeIcon
                  icon={faTrash}
                  style={{ fontSize: "1rem", color: "" }}
                />
                <FontAwesomeIcon
                  icon={faInfo}
                  style={{ fontSize: "1rem", color: "" }}
                />
                <FontAwesomeIcon
                  icon={faHeart}
                  style={{ fontSize: "1rem", color: "" }}
                />
              </div>
              <div
                className="bootiesNb"
                style={{
                  bottom: ".2rem",
                  fontSize: "1rem",
                  position: "absolute",
                  right: "1.2rem",
                }}
              >
                {cardNb || 0}
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <div id="footerBar">
        <img
          className="footerBar_logoLoginSignup"
          src="/images/icon-blanche.png"
          alt=""
        />
        <div id="footerBarAd">
          <p>
            Téléchargez l'application <br /> Carte Verte
          </p>
          <div id="footerBarAdIcons">
            <img
              className="footerBarAdIcons_googlePlay"
              alt="GooglePlay"
              src="/images/googlePlay.svg"
            />
            <img
              className="footerBarAdIcons_appStore"
              alt="AppStore"
              src="/images/appStore.svg"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export { QRCodePage as default };

// import React from "react";
// import QRCode from "qrcode";
// import { useQuery, useMutation, useSubscription } from "@apollo/react-hooks";
// import { ME_OWNER } from "../../actions/queries";
// import { UPDATE_QRCODE } from "../../actions/mutations";
// import { MYQRCODE as MYQRCODE_SUB } from "../../actions/subscriptions";
// import { useHistory, Link } from "react-router-dom";
// import Navbar_account from "../Layout/Navbar_account";
// import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTrash, faInfo, faHeart } from "@fortawesome/free-solid-svg-icons";

// // 1- generate QR code here
// // 2- mutation to hash and store it
// // 3- mutation to validate it (updateCard)
// // 4- sub to detect qr code validation
// // 5- on change => step 1

// window.qrc = true;
// let qrCode;

// document.cookie = `addressIdx=${
//   window.location.href.includes("address=")
//     ? window.location.href.split("address=")[1].split("idx")[0]
//     : "0"
// }`;

// const QRCodePage = () => {
//   const history = useHistory();
//   const [updateQRCode, { loading: updateQRCodeLoading }] =
//     useMutation(UPDATE_QRCODE);
//   const { loading, error, data } = useQuery(ME_OWNER);
//   const { data: subData, error: subErr } = useSubscription(MYQRCODE_SUB);

//   let id = "";
//   if (updateQRCodeLoading) {
//     return (
//       <div className="loaderParent">
//         <div className="loader"></div>
//       </div>
//     );
//   }
//   if (loading) {
//     return (
//       <div className="loaderParent">
//         <div className="loader"></div>
//       </div>
//     );
//   } else if (error || !data.meOwner.email) {
//     console.log(`${error.message}`);
//     sessionStorage.removeItem("loggedIn");
//     history.push("/login");
//     return null;
//   } else if (data) {
//     id = data.meOwner.id;
//   }
//   if (window.qrc) {
//     window.qrc = false;
//     qrCode = ((Math.random() + 0.345 * Math.random() + 0.34987) * 3876544687)
//       .toFixed(10)
//       .toString();
//     let qrCodeIdx = 0;
//     if (window.location.href.includes("address"))
//       qrCodeIdx = Number(
//         window.location.href.split("address=")[1]?.replace("idx", "")
//       );

//     qrCode += ";" + qrCodeIdx;
//     updateQRCode({
//       variables: {
//         data: {
//           id,
//           qrCode,
//         },
//       },
//     });
//   } else {
//     window.qrc = true;
//     updateQRCode({
//       variables: {
//         data: {
//           id,
//           qrCode,
//         },
//       },
//     });
//   }
//   if (updateQRCodeLoading) {
//     return "Load...";
//   }

//   if (subErr) console.log("subErr:", subErr);
//   else if (subData) {
//     console.log("subData", subData);
//   }

//   let opts = {
//     errorCorrectionLevel: "H",
//     type: "image/jpeg",
//     quality: 0.3,
//     margin: 2,
//     color: {
//       dark: "#FFF",
//       light: "#000",
//     },
//   };
//   let qrCodeUrl = "";
//   const generateQR = (code) => {
//     QRCode.toDataURL(code, opts, function (err, url) {
//       if (err) throw err;

//       qrCodeUrl = url;
//     });
//     return qrCodeUrl;
//   };

//   const textColor = data.meOwner.textColor;
//   const squaresRow1 = [];
//   const squaresRow2 = [];
//   const squaresRow3 = [];
//   let offer;
//   let squares;
//   let cardNb;
//   if (subData) {
//     squares = subData.myqrcode.split(";")[0];
//     if (!squares.includes("1")) squares = "111111111111111"; // card completed

//     offer = subData.myqrcode.split(";")[1];

//     cardNb =
//       1 +
//       parseInt(
//         subData.myqrcode.split(";")[2] /
//           (offer == 1 || offer == 2 || offer == 3 ? 10 : offer == 4 ? 11 : 15)
//       );
//     if (!squares.includes("0")) cardNb--; // card completed

//     const offer10squares1 = offer == 1;
//     const offer10squares2 = offer == 2;
//     const offer10squares3 = offer == 3;
//     const offer15squares = offer == 5;
//     const offer15squares2 = offer == 6;

//     let size = offer15squares || offer15squares2 ? "3.3rem" : "4rem";

//     for (let i = 0; i < 5; i++) {
//       if (data.meOwner.logo && squares && squares[i] == "1")
//         squaresRow1.push(
//           <img
//             className="square sq"
//             style={{ height: size, width: size }}
//             src={data.meOwner.logo}
//             alt=""
//           ></img>
//         );
//       else
//         squaresRow1.push(
//           <div
//             className="square"
//             style={{
//               alignItems:
//                 offer15squares || offer15squares2 ? "baseline" : "end",
//               border: `solid ${textColor || "#000000"}`,
//               display: "flex",
//               fontSize: "2rem",
//               height: size,
//               justifyContent: "center",
//               width: size,
//             }}
//           >
//             {(offer15squares || offer15squares2 || offer10squares1) && i == 4
//               ? "%"
//               : ""}
//           </div>
//         );
//     }
//     for (let i = 5; i < 10; i++) {
//       if (data.meOwner.logo && squares && squares[i] == "1")
//         squaresRow2.push(
//           <img
//             className="square sq"
//             style={{ height: size, width: size }}
//             src={data.meOwner.logo}
//             alt=""
//           ></img>
//         );
//       else
//         squaresRow2.push(
//           <div
//             className="square"
//             style={{
//               alignItems:
//                 offer15squares || offer15squares2 ? "baseline" : "center",
//               border: `solid ${textColor}`,
//               display: "flex",
//               fontSize:
//                 offer15squares || offer15squares2 || offer10squares3
//                   ? "2rem"
//                   : "1.2rem",
//               height: size,
//               justifyContent: "center",
//               textAlign: "center",
//               width: size,
//             }}
//           >
//             {(offer15squares || offer15squares2 || offer10squares3) && i == 9
//               ? "%"
//               : ""}
//             <span
//               style={{
//                 color: textColor,
//                 fontWeight: "bold",
//                 // transform: "rotate(-45deg)",
//               }}
//             >
//               {(offer10squares1 || offer10squares2) && i == 9 ? "FREE" : ""}
//             </span>
//           </div>
//         );
//     }
//     if (offer15squares || offer15squares2)
//       for (let i = 10; i < 15; i++) {
//         if (data.meOwner.logo && squares && squares[i] == "1")
//           squaresRow3.push(
//             <img
//               className="square sq"
//               style={{ height: size, width: size }}
//               src={data.meOwner.logo}
//               alt=""
//             ></img>
//           );
//         else
//           squaresRow3.push(
//             <div
//               className="square"
//               style={{
//                 alignItems: "center",
//                 border: `solid ${textColor}`,
//                 display: "flex",
//                 fontSize: offer15squares ? "1rem" : "2rem",
//                 height: size,
//                 justifyContent: "center",
//                 width: size,
//               }}
//             >
//               <span
//                 style={{
//                   color: textColor,
//                   fontWeight: offer15squares ? "bold" : "normal",
//                 }}
//               >
//                 {offer15squares && i == 14
//                   ? "FREE"
//                   : offer15squares2 && i == 14
//                   ? "%"
//                   : ""}
//               </span>
//             </div>
//           );
//       }
//   }

//   const handleOpacity = () => {
//     if (subData) {
//       setTimeout(() => {
//         if (document.getElementById("qrcodeCard") != null)
//           document.getElementById("qrcodeCard").style.opacity = 0;
//       }, 5000);
//       return "1";
//     }
//   };

//   document.title = "Carte Verte : Code QR";

//   return (
//     <div id="qrcodePage">
//       {/* <Navbar_account isActive="hidden" /> */}
//       <div style={{ display: "flex" }}>
//         <div id="imgContainer">
//           <img
//             className="logoLoginSignup"
//             src="/images/icon-blanche.png"
//             alt=""
//           />
//           <div id="ad">
//             Téléchargez l'application <br />
//             Carte Verte.
//             <br />
//             <br />
//             {/* <a
//               href="https://play.google.com/store/apps/details?id=com.carte_verte"
//               target="_blank"
//               rel="noopener noreferrer"
//             > */}
//             <img
//               className="googlePlay"
//               alt="GooglePlay"
//               src="/images/googlePlay.svg"
//             />
//             {/* </a> */}
//             <img
//               className="appStore"
//               alt="AppStore"
//               src="/images/appStore.svg"
//             />
//           </div>
//         </div>
//         <div id="contentContainer">
//           {/* <Link className="returnLink" to="/mon-compte"> */}
//           <a className="returnLink" href="/mon-compte">
//             <FontAwesomeIcon
//               icon={faArrowLeft}
//               style={{ fontSize: "1.4rem", marginRight: "1rem" }}
//             />
//             Mon compte
//           </a>
//           {/* </Link> */}
//           <div id="qrcodeContainer">
//             <div id="qrcodeMsgandImg">
//               <p id="qrcodeMsg">
//                 Scannez ce code QR pour tamponner votre carte sur l'app Carte
//                 Verte
//               </p>
//               <img
//                 id="img"
//                 src={qrCode === "" ? "" : generateQR(qrCode.toString())}
//                 alt=""
//               ></img>
//             </div>

//             <div
//               id="qrcodeCard"
//               className="frontCard"
//               style={{
//                 backgroundColor: data.meOwner.color,
//                 color: textColor,
//                 opacity: handleOpacity(subData),
//                 visibility: subData ? "visible" : "hidden",
//               }}
//             >
//               {offer != 4 ||
//               (offer == 4 && squares.split("1").length - 1 < 10) ? (
//                 <div
//                   style={{
//                     alignContent: "space-around",
//                     display: "flex",
//                     // flexDirection: "Column",
//                     flexWrap: "wrap",
//                     height: "14rem",
//                     justifyContent: "center",
//                     padding: "1rem",
//                     width: "30rem",
//                   }}
//                 >
//                   <div id="squares">{squaresRow1}</div>
//                   <div id="squares">{squaresRow2}</div>
//                   <div id="squares">{squaresRow3}</div>
//                 </div>
//               ) : (
//                 <div
//                   style={{
//                     alignContent: "space-around",
//                     display: "flex",
//                     flexDirection: "Column",
//                     flexWrap: "wrap",
//                     height: "14rem",
//                     justifyContent: "center",
//                     padding: "1rem",
//                     width: "30rem",
//                   }}
//                 >
//                   {offer == 4 && squares.split("1").length - 1 == 10 ? (
//                     <div
//                       className="square"
//                       style={{
//                         alignItems: "center",
//                         border: `solid ${textColor}`,
//                         display: "flex",
//                         fontSize: "1.2rem",
//                         height: "6rem",
//                         justifyContent: "center",
//                         textAlign: "center",
//                         width: "6rem",
//                       }}
//                     >
//                       <span
//                         style={{
//                           color: textColor,
//                           fontWeight: "bold",
//                         }}
//                       >
//                         FREE
//                       </span>
//                     </div>
//                   ) : (
//                     <img
//                       className="square sq"
//                       style={{ height: "8rem", width: "8rem" }}
//                       src={data.meOwner.logo}
//                       alt=""
//                     ></img>
//                   )}
//                 </div>
//               )}
//               <div id="icons">
//                 <FontAwesomeIcon
//                   icon={faTrash}
//                   style={{ fontSize: "1rem", color: "" }}
//                 />
//                 <FontAwesomeIcon
//                   icon={faInfo}
//                   style={{ fontSize: "1rem", color: "" }}
//                 />
//                 <FontAwesomeIcon
//                   icon={faHeart}
//                   style={{ fontSize: "1rem", color: "" }}
//                 />
//               </div>
//               <div
//                 className="bootiesNb"
//                 style={{
//                   bottom: ".2rem",
//                   fontSize: "1rem",
//                   position: "absolute",
//                   right: "1.2rem",
//                 }}
//               >
//                 {cardNb || 0}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div id="footerBar">
//         <img
//           className="footerBar_logoLoginSignup"
//           src="/images/icon-blanche.png"
//           alt=""
//         />
//         <div id="footerBarAd">
//           <p>
//             Téléchargez l'application <br /> Carte Verte
//           </p>
//           <div id="footerBarAdIcons">
//             <img
//               className="footerBarAdIcons_googlePlay"
//               alt="GooglePlay"
//               src="/images/googlePlay.svg"
//             />
//             <img
//               className="footerBarAdIcons_appStore"
//               alt="AppStore"
//               src="/images/appStore.svg"
//             />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export { QRCodePage as default };
